/**
 * Copyright (C) 2022, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: BSReelContainer.ts ,v 1.0 Exp $
 * Date Author Changes
 * Feb 22, 2022 Shruti Agrawal Created
 *
 */

namespace Reels {
    export class BSReelContainer extends ReelContainer {        
        public injectResponse(response: DTO.GameActionResponse): void {
            for (let reel of this.reels) {
                let spinPhase = reel.animation.getAnimationPhaseById(ReelAnimationPhaseId.REEL_SPIN_PHASE) as ReelSpinPhaseClientPadding;
                if (spinPhase) {
                    spinPhase.result = response.gameResult;
                }
            }
        }
    }
}
